// sensei-app/client/widgets/ActivityTypeDistributionWidget.widget.js
export default {
    name: "ActivityTypeDistributionWidget",
    type: "ChartWidget",
    description: "Pie chart showing the distribution of completed activities by type.",
    roles: ["student"],
    widget: {
        title: "Activity Breakdown",
        size: "medium",
        dataProvider: {
            main: {
                rpc: "StudentRpc.getActivityTypeDistribution"
            }
        },
        chartType: 'pie',
        labelsField: 'type',
        dataField: 'count',
        datasetOptions: {
            label: "Completed Activities",
            backgroundColor: [
                'var(--bs-primary)',
                'var(--bs-info)',
                'var(--bs-success)',
                'var(--bs-warning)',
                'var(--bs-secondary)'
            ],
            borderColor: 'var(--bs-body-bg)', 
            borderWidth: 2,
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'right', }, title: { display: false } }
        },
        noDataMessage: "Complete some activities to see your breakdown."
    }
};